/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]     .button{background-color:transparent}.btn_close[_ngcontent-%COMP%]   svg[_ngcontent-%COMP%]{fill:#fff}@media screen and (min-width:1280px){.btn_close[_ngcontent-%COMP%]   svg[_ngcontent-%COMP%]{width:40px;height:auto}}.is-empty[_ngcontent-%COMP%]{position:relative;width:100%}.is-empty[_ngcontent-%COMP%]:before{content:\"\";position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);width:.8rem;height:1px;background-color:#fff}"];
export { styles as styles };
